<template>
  <div>
    <SupportEnUS v-if="lang === 'en-US'" />
    <SupportJa v-else-if="lang === 'ja'" :plan="plan" />
  </div>
</template>

<script>
import SupportJa from "@/components/devices/support/support.ja.vue";
import SupportEnUS from "@/components/devices/support/support.en-US.vue";
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { ImsrTenants } from "@/lib/imsrTenants.js";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";

export default {
  components: {
    SupportJa,
    SupportEnUS,
  },
  setup() {
    const { locale } = useI18n();
    const store = useStore();
    const plan = ref("");

    const loadTenant = async () => {
      try {
        const imsrTenants = new ImsrTenants();
        const res = await imsrTenants.getTenant(store.getters.tenantId);
        plan.value = res.plan;
      } catch (e) {
        plan.value = "";
      }
    };
    loadTenant();

    return {
      lang: computed(() => {
        return locale.value;
      }),
      plan,
    };
  },
};
</script>
